interface ProcessingStatusProps {
  visible: boolean;
  message: string;
  error?: string;
  completed?: number;
  total?: number;
  phase?: 'uploading' | 'queued' | 'processing' | 'preparing' | 'success' | 'error';
}

export default function ProcessingStatus({ visible, message, error = '', completed, total, phase = 'processing' }: ProcessingStatusProps) {
  if (!visible && !error) return null;
  const hasCount = Number.isFinite(completed) && Number.isFinite(total) && (total || 0) > 0;
  const percent = hasCount ? Math.round(Math.max(0, Math.min(1, (completed || 0) / (total || 1))) * 100) : 0;
  const isError = Boolean(error) || phase === 'error';
  const text = error || message;
  return (
    <div className={`processing-status ${isError ? 'processing-status--error' : ''}`} role={isError ? 'alert' : 'status'} aria-live="polite" aria-atomic="true">
      <div className="processing-status-row">
        <strong>{text}</strong>
        {hasCount && <span>{completed} von {total} abgeschlossen</span>}
      </div>
      <div className={`processing-status-track ${hasCount ? '' : 'processing-status-track--indeterminate'}`} role="progressbar" aria-label={hasCount ? 'Bildbearbeitung Fortschritt' : 'Bildbearbeitung läuft'} aria-valuemin={0} aria-valuemax={hasCount ? 100 : undefined} aria-valuenow={hasCount ? percent : undefined} aria-valuetext={hasCount ? `${completed} von ${total} Bildern abgeschlossen` : text}>
        <span style={hasCount ? { width: `${percent}%` } : undefined} />
      </div>
    </div>
  );
}
